<section
  class="bg-white mt-6 px-8 pb-4 pt-8 rounded-3xl w-full relative flex justify-center transition-all duration-300"
>
  <!-- Tabs -->
  <div class="absolute -top-6">
    <div
      class="bg-white shadow w-fit flex justify-center gap-3 p-1.5 lg:p-2 rounded-full"
    >
      <button
        *ngFor="let tab of tabs; let i = index"
        (click)="selectTab(i)"
        [ngClass]="selectedTab === i ? 'bg-black text-white' : 'text-gray-600'"
        class="py-1 px-4 cursor-pointer rounded-full text-sm lg:text-base"
      >
        {{ tab.label }}
      </button>
    </div>
  </div>
  <form
    *ngIf="selectedTab === 0"
    class="w-full grid md:grid-cols-2 2xl:grid-cols-4 items-center md:gap-5 lg:gap-5"
  >
    <out-select
      [id]="'model'"
      [name]="'model'"
      [items]="options.model"
      selectClass="!border-b !border-x-0 !border-t-0 !rounded-none !py-3"
      [control]="getControl('model')"
    >
    </out-select>

    <out-select
      [id]="'year'"
      [name]="'year'"
      [items]="options.year"
      selectClass="!border-b !border-x-0 !border-t-0 !rounded-none !py-3"
      [control]="getControl('year')"
    >
    </out-select>
    <out-select
      [id]="'location'"
      [name]="'location'"
      [items]="options.location"
      [control]="getControl('location')"
      selectClass="!border-b !border-x-0 !border-t-0 !rounded-none !py-3"
    >
    </out-select>
    <button
      tabindex="0"
      type="button"
      (click)="goToSearchUrl()"
      class="bg-OUT-Blue cursor-pointer hover:bg-OUT-Blue/90 transition-colors duration-400 w-full rounded-full px-5 py-2 text-white md:mb-7 lg:mb-3.5 lg:-mt-4 font-semibold ring-2 ring-OUT-Blue ring-offset-2 ring-offset-white"
    >
      Search
    </button>
  </form>

  <div
    *ngIf="selectedTab === 1"
    class="flex flex-col lg:flex-row items-center gap-4 lg:gap-2.5 pt-6 pb-4"
  >
    <p
      *ngIf="(auth.isAuthenticated$ | async) === false"
      class="xl:w-[80%] w-full"
    >
      <strong>Thinking of selling your Tesla?</strong> Register for free at Only
      Used Tesla to connect with passionate buyers and access exclusive features
      for the best deal.
    </p>
    <p *ngIf="auth.isAuthenticated$ | async">
      <strong>Thinking of selling your Tesla?</strong> Click on 'Sell My Tesla'
      to start listing your Tesla now
    </p>
    <button
      [routerLink]="
        (auth.isAuthenticated$ | async) ? '/your-tesla' : '/sell-my-tesla'
      "
      class="bg-OUT-Blue cursor-pointer hover:bg-OUT-Blue/90 w-full lg:w-[20%] px-5 py-2 text-white font-semibold hover:bg-OUT-Blue/90 transition-colors duration-400  rounded-full px-5 py-2 lg:-mt-4  ring-2 ring-OUT-Blue ring-offset-2 ring-offset-white"
    >
      Sell My Tesla
    </button>
  </div>
</section>
